import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { MenCategoryThumbnails, WomenCategoryThumbnails } from "../../utility/CategoryThumbnails"
import { CategoriesSortHomePage, CITIES, NewsFeedGroupedCategories, primaryTags } from "../../constants"
import axios, { isAxiosError } from "axios"
import Loadingwrapper from "../../component/LoadingWrapper"
import NewsFeedTrend from "./Trend"
import useCollectionNames from "../../hooks/useCollectionNames"
import useAddImageToCollection from "../../hooks/useAddImageToCollection"
import DepthToolTip from "../../component/DepthTooltip"
import TrendTooltip from "../../component/TrendsTooltip"
import { Accordion, AccordionDetails, AccordionSummary, Box, Slider, Switch } from "@mui/material"
import { Filter } from "@mui/icons-material"
import { isMobile } from "react-device-detect"
import { FaFilter } from "react-icons/fa"
import { useSelector } from "react-redux"
import ValidatedTrendsFilters from "./ValidatedTrendsFilters"
import NewsFeedShareImagePopup from "./NewsFeedShareImagePopup/ImagePopup"
import TabularNewsFeed from "./TabularNewsFeed"
import { SentenceCase } from "../../utility/helper_functions"
import Popup from "../../component/Popup"
import TrendImages from "../V2Leaderboard/TrendImages"
import NewMeComponent from "../../component/NewMeComponent"
import NewmeCsvDownload from "./NewmeCsvDownload"
import MinimumForecastDropdown from "./MinimumForecastDropdown"
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage"
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5"
import { IoIosRemoveCircle } from "react-icons/io"
import StyleProcureCountUpdate from "./components/StyleProcureCountUpdate"

const NewsFeed = ({ forAllTrends }) => {
  const [searchParams, setSearchParams] = useSearchParams({ type: "social", city: "", retailertime: "90", "min-forecast": 0, ['retailer-collection-id']: '' })
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)
  const [trends, setTrends] = useState([])
  const [tabularTrends, setTabularTrends] = useState([])
  const [allCollectionNames, socialcollectionSets, retailercollectionSets, getCollectionNames] = useCollectionNames()
  const [hidebelow25percenttrends, sethidebelow25percenttrends] = useState(false)
  const userLoggedIn = useSelector(state => state.userLoggedIn)
  const styleProcureCounts = useSelector(state => state.styleProcureCounts)
  const [validationFilters, setValidationFilters] = useState({ minProducts: "2", weeks: `4` })
  const [imagePopupData, setImagePopupData] = useState(null)
  const [showTabular, setShowTabular] = useState(searchParams.get('tabular') == 't')
  const [page, setPage] = useState(1);
  const addImageToCollection = useAddImageToCollection()
  const [showGeographyAndCategoryFilter, setShowGeographyAndCategoryFilter] = useState(false)
  const [selectedTrend, setSelectedTrend] = useState(null)
  const [minimumForecastOptions, setMinimumForecastOptions] = useState([{ count: 1, value: 0 }])
  const [showNewmeComponent, setShowNewmeComponent] = useState(false)
  const [retailerKey, setRetailerKey] = useState(`count${searchParams.get('retailertime')}days`)
  const setImagePopupDataWrapper = (e) => {
    if (!e || !e.target || !e.target.id) {
      return
    }

    let [category, tag, value, shareTag, shareValue] = e.target.id.split('__')
    if (shareTag == 'silhouette') {
      const categoryPrimaryTags = primaryTags[category] || []
      // to fix , can be multiple silhouettes in category
      shareTag = categoryPrimaryTags[0]
    }

    const gender = searchParams.get('gender');
    setImagePopupData({ tag, value, gender, category, shareTag, shareValue })
  }

  useEffect(() => {
    const newValue = userLoggedIn.curator || userLoggedIn.company == 'newme' || userLoggedIn.company == 'trent' || userLoggedIn.company == 'cocoblu' || userLoggedIn.company == 'Ajio' ? true : false
    setShowNewmeComponent(newValue)
  }, [userLoggedIn])

  const socialAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, socialcollectionSets, 'social', getCollectionNames);
  }

  const retailerAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, retailercollectionSets, 'retailer', getCollectionNames);
  }

  const hideTrend = async (trendId, isDelete) => {
    const response = await axios.post(`/api/news-feed/delete`, { trendId: trendId, delete: isDelete })
    if (response.data.success) {
      setTrends(prev => {
        const next = [...prev];
        next.forEach(trend => {
          if (trend._id == trendId) {
            trend.deleted = isDelete
          }
        })
        return next;
      })

      setTabularTrends(prev => {
        const next = [...prev];
        next.forEach(trend => {
          if (trend._id == trendId) {
            trend.deleted = isDelete
          }
        })
        return next;
      })
    }
  }

  useEffect(() => {
    setRetailerKey(`count${searchParams.get('retailertime')}days`)
  }, [searchParams.get('retailertime')])

  useEffect(() => {
    setSearchParams(prev => {
      prev.set('gender', prev.get('gender') || 'F')
      prev.set('category', prev.get('category') != null ? prev.get('category') : 'apparel')
      prev.set('sort', prev.get('sort') || 'rog')
      prev.set('geography', prev.get('geography') || 'All')
      prev.set('alltrends', prev.get('alltrends') || "")
      return prev;
    })
  }, [searchParams.get('gender'), searchParams.get('category')])
  const getTrends = async (signal) => {
    setLoading(true)
    try {
      let validationString = ''
      if (searchParams.get('validated') == 'true') {
        validationString = `&validated=true&weeks=${validationFilters.weeks}&minProducts=${validationFilters.minProducts}`

      }
      let trendsTypeString = ""
      if (searchParams.get("type") == "retailer") {
        trendsTypeString = "&type=retailer"
      }
      let collectionId = ""
      if (searchParams.get('retailer-collection-id')) {
        collectionId = "&retailer-collection-id=" + searchParams.get('retailer-collection-id')
      }
      let shortListedTrendsString = ''
      if (searchParams.get('shortlisted-trends') == 't') {
        shortListedTrendsString = '&shortlisted=t'
      }
      const response = await axios.get(`/api/news-feed/trends?gender=${searchParams.get('gender')}&category=${encodeURIComponent(searchParams.get('category'))}&page=${page}&geography=${searchParams.get('geography') || 'All'}&sort=${searchParams.get('sort') || 'rog'}&alltrends=${searchParams.get('alltrends') || ''}${validationString}${trendsTypeString}&city=${searchParams.get('city') || ''}&minimumforecast=${searchParams.get('tabular') != 't' && searchParams.get('min-forecast') || 0}&tabular=${searchParams.get('tabular')}${collectionId}${shortListedTrendsString}`, { signal })
      setLoading(false)
      setCount(response.data.count)
      const newOptions = response.data.forecastOptions
      if (JSON.stringify(newOptions) != JSON.stringify(minimumForecastOptions)) {
        setMinimumForecastOptions(response.data.forecastOptions)
      }
      if (userLoggedIn && userLoggedIn.curator) {
        sethidebelow25percenttrends(response.data.hidebelow25percenttrends)
      }

      let trends = response.data.trends
      const company = userLoggedIn ? (userLoggedIn.curator ? 'newme' : userLoggedIn.company == 'trent' ? 'westside' : userLoggedIn.company == 'Ajio' ? "Ajio" : userLoggedIn.company) : ''

      if (showTabular) {
        if (searchParams.get('sort') != 'depth') {
          setTabularTrends(trends)
        }
        if (searchParams.get('sort') == 'depth') {
          const newTrends = [...trends].sort((a, b) => b.depth - a.depth)
          setTabularTrends(newTrends)
        }
      } else {
        setTrends(prev => {
          const next = page == 1 ? trends : [...prev, ...trends]
          return next
        })
      }
      updateProductCounts()
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
        setLoading(false)
      }
    }
  }

  const updateProductCounts = () => {
    const companyName = userLoggedIn ? (userLoggedIn.curator ? 'newme' : userLoggedIn.company == 'trent' ? 'westside' : userLoggedIn.company == 'Ajio' ? "Ajio" : userLoggedIn.company) : ''
    if (searchParams.get('tabular') == 't') {
      setTabularTrends((prev) => {
        const next = [...prev]
        next.forEach(trend => {
          trend.recommendedCount = Math.round(
            (trend.forecastShare && trend.forecastShare * 100 >= 0
              ? trend.forecastShare * 100
              : 0)
            * (styleProcureCounts[trend.gender] && styleProcureCounts[trend.gender][trend.category] ? styleProcureCounts[trend.gender][trend.category] : 0) / 100)
          trend.companyCount = trend[companyName + 'retailerTimeCount'] && trend[companyName + 'retailerTimeCount'][retailerKey] ? trend[companyName + 'retailerTimeCount'][retailerKey] : 0
          trend.gapInRecommendation = trend.recommendedCount - trend.companyCount
        })
        return [...next]
      })
    } else {
      setTrends((prev) => {
        const next = [...prev]
        next.forEach(trend => {
          trend.recommendedCount = Math.round(
            (trend.forecastShare && trend.forecastShare * 100 >= 0
              ? trend.forecastShare * 100
              : 0)
            * (styleProcureCounts[trend.gender] && styleProcureCounts[trend.gender][trend.category] ? styleProcureCounts[trend.gender][trend.category] : 0) / 100)
          trend.companyCount = trend[companyName + 'retailerTimeCount'] && trend[companyName + 'retailerTimeCount'][retailerKey] ? trend[companyName + 'retailerTimeCount'][retailerKey] : 0
          trend.gapInRecommendation = trend.recommendedCount - trend.companyCount
        })
        return [...next]
      })
    }
  }

  useEffect(() => {
    updateProductCounts()

  }, [retailerKey, userLoggedIn.company, styleProcureCounts])
  useEffect(() => {
    setSearchParams(prev => {
      if (prev.get('type') == 'retailer')
        prev.set('sort', 'depth')
      return prev
    })
  }, [searchParams.get('type')])
  useEffect(() => {
    setSearchParams(prev => {
      prev.set('type', 'social')
      return prev
    })
  }, [searchParams.get('gender')])
  useEffect(() => {
    setLoading(true)
    const abortController = new AbortController()
    const signal = abortController.signal

    getTrends(signal)

    return () => {
      abortController.abort()
    }
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('sort'), searchParams.get('geography'), searchParams.get('alltrends'), page, searchParams.get('validated'), validationFilters.weeks, validationFilters.minProducts, searchParams.get("type"), searchParams.get('city'), searchParams.get('tabular'), searchParams.get('retailer-collection-id'), searchParams.get('shortlisted-trends')])

  useEffect(() => {
    setTrends([])
    setTabularTrends([])
    setSearchParams(prev => {
      prev.set('tabular', showTabular ? 't' : 'f')
      return prev
    })
  }, [showTabular])

  const updateHideBelow25PercentTrends = async (e) => {
    const value = !(e.target.checked)
    await axios.post(`/api/news-feed/update-hidebelow-25-percent`, { hidebelow25percenttrends: value }).then((res) => {
      sethidebelow25percenttrends(value)
    })
  }

  useEffect(() => {
    setTrends([])
    setTabularTrends([])
    setPage(1)
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('sort'), searchParams.get('geography'), searchParams.get('alltrends'), searchParams.get('validated'), validationFilters.weeks, validationFilters.minProducts, searchParams.get("type"), searchParams.get('city'), searchParams.get('retailer-collection-id'), searchParams.get('shortlisted-trends')])


  useEffect(() => {
    if (searchParams.get('tabular') != 't') {
      setTrends([])
      setTabularTrends([])
      setPage(1)
      setLoading(true)
      const abortController = new AbortController()
      const signal = abortController.signal
      getTrends(signal)
      return () => {
        abortController.abort()
      }
    }
  }, [searchParams.get('min-forecast')])

  return <div>
    <h2 className="text-center font-semibold text-2xl lg:text-[32px] p-0.5 lg:p-2">
      {(searchParams.get('geography') == 'indian' && searchParams.get('category') == 'apparel')
        ? 'India Tier I & II Newsfeed'
        : searchParams.get('category') == 'apparel' || searchParams.get('category') == 'non-apparel'
          ? <>{searchParams.get('gender') == 'M' ? 'Men' : 'Women'}'s {searchParams.get('category') == 'non-apparel' ? 'Non ' : ""}Apparel Feed</>
          : (searchParams.get('category') && NewsFeedGroupedCategories.filter(cat => cat.values.join(',,') == searchParams.get('category')).length > 0)
            ? <>{searchParams.get('gender') == 'M' ? 'Men' : 'Women'}'s {NewsFeedGroupedCategories.filter(cat => cat.values.join(",,") == searchParams.get('category'))[0].name} Feed</>
            : <>{searchParams.get('alltrends') == 'color' ? 'COLOR ' : ''}NEWS FEED {searchParams.get('gender') == 'M' ? 'Men' : 'Women'}'s {searchParams.get('category') || 'All Categories'}</>
      }
    </h2>
    <div className="sticky top-11 lg:top-10 z-10 bg-white" >
      <div className="w-screen flex justify-between flex-wrap">

        <div className="w-screen shrink-0 lg:shrink-1   flex lg:p-2 lg:px-2 flex-wrap justify-center lg:justify-start">
          {
            userLoggedIn && userLoggedIn.curator && searchParams.get('gender') == 'M' ?
              <div className="flex lg:shrink lg:w-auto text-lg font-semibold justify-center mb-2">
                <div
                  className="mx-0.5 flex"
                  onClick={() => {
                    setSearchParams(prev => {
                      if (prev.get('type') == 'social') return prev;
                      prev.set('type', 'social');
                      return prev
                    })
                  }}>
                  <input type="radio" name="type" value="social" checked={searchParams.get('type') == 'social'} />
                  <label htmlFor="social" className="pl-1 pr-2 ">Social</label>
                </div>
                <div
                  className="mx-0.5 flex"
                  onClick={() => {
                    setSearchParams(prev => {
                      if (prev.get('type') == 'retailer') return prev;
                      prev.set('type', 'retailer');
                      return prev
                    })
                  }}>
                  <input type="radio" name="type" value="retailer" checked={searchParams.get('type') == 'retailer'} />
                  <label htmlFor="retailer" className="pl-1 pr-2 ">Retailer</label>
                </div>
              </div>
              : null}

          {false && forAllTrends && <div className="flex mx-2 pt-2 text-[10px] lg:text-[14px]" >
            <div
              className="mx-0.5 flex"
              onClick={() => {
                setSearchParams(prev => {
                  if (prev.get('gender') == 'F') return prev;
                  prev.set('category', '')
                  prev.set('gender', 'F');
                  return prev
                })
              }}>
              <input type="radio" name="gender" value="F" checked={searchParams.get('gender') == 'F'} />
              <label htmlFor="F" className="pl-1 pr-2 pt-2">Female</label>
            </div>
            <div
              className="mx-0.5 flex"
              onClick={() => {
                setSearchParams(prev => {
                  if (prev.get('gender') == 'M') return prev;
                  prev.set('category', '')
                  prev.set('gender', 'M');
                  return prev
                })
              }}>
              <input type="radio" name="gender" value="M" checked={searchParams.get('gender') == 'M'} />
              <label htmlFor="M" className="pl-1 pr-2 pt-2">Male</label>
            </div>
          </div>
          }
          {searchParams.get('alltrends') != 'color' && ['apparel', 'non-apparel'].includes(searchParams.get('category')) ? <div className="mr-4 flex w-full shrink-0 lg:shrink lg:w-auto text-lg font-semibold justify-center mb-2">
            <div
              className="mx-1"
              onClick={() => {
                setSearchParams(prev => {
                  if (prev.get('alltrends') == '') return prev;
                  prev.set('alltrends', '');
                  return prev
                })
              }}>
              <input type="radio" name="alltrends" value="" checked={searchParams.get('alltrends') == ''} />
              <label htmlFor="" className="pl-1 pr-2">All Trends</label>
            </div>
            <div
              className="mx-1"
              onClick={() => {
                setSearchParams(prev => {
                  if (prev.get('alltrends') == 'color,pattern') return prev;
                  prev.set('alltrends', 'color,pattern');
                  return prev
                })
              }}>
              <input type="radio" name="alltrends" value="color,pattern" checked={searchParams.get('alltrends') == 'color,pattern'} />
              <label htmlFor="color,pattern" className="pl-1 pr-2">Color Trends</label>
            </div>
          </div> : null}
          <div className="w-full max-w-full lg:w-auto shrink-0 flex  lg:mx-2 lg:pt-0  text-sm lg:text-[14px] flex-wrap">
            {forAllTrends && <select className='mx-2 p-1  lg:w-auto  rounded    border-slate-300 border  ' value={searchParams.get('category')} onChange={(e) => {
              setSearchParams(prev => {
                prev.set('category', e.target.value);
                return prev;
              })
            }}>
              <option value={"select cat"} disabled>--Category--</option>
              <option value={""} >All Categories</option>
              <option value={"apparel"} >Apparel</option>
              <option value={"non-apparel"} >Non Apparel</option>
              {
                (
                  searchParams.get('gender') == 'M'
                    ? NewsFeedGroupedCategories.filter(cat => (!["Skirts", "Dresses & Jumpsuits", "Lingerie & Swimwear"].includes(cat.name)))
                    : NewsFeedGroupedCategories
                ).map(cat => <option key={cat.name} value={cat.values.join(',,')}>{cat.name}</option>)
              }
            </select>
            }
            {searchParams.get('alltrends') != 'color' ? <select className='px-2 rounded py-1 border-slate-300 border mx-1' value={searchParams.get('geography')} onChange={(e) => {
              setSearchParams(prev => {
                prev.set('geography', e.target.value);
                return prev;
              })
            }}
              hidden={searchParams.get('gender') == 'M'}
            >
              <option value={""} disabled>--Geography--</option>
              <option value={"All"}>All Geography</option>
              <option value={"asian"}>Asian</option>
              <option value={"indian"}>Indian</option>
              <option value={"western"}>Western</option>
            </select> : null}

            {searchParams.get('alltrends') != 'color' ? <select className='px-2 rounded py-1 border-slate-300 border mx-1'
              value={searchParams.get('city')}
              onChange={(e) => {
                setSearchParams(prev => {
                  prev.set('city', e.target.value);
                  prev.set('geography', 'All');
                  return prev;
                })
              }}
              hidden={searchParams.get('gender') == 'M'}
            >
              <option value={"select-city"} disabled>--City--</option>
              <option value={""} >All Cities</option>
              {CITIES.map(city => <option key={city} value={city}>{SentenceCase(city)} - Beta</option>)}
            </select> : null}
            <div className="w-full lg:w-auto shrink-0 lg:shrink flex flex-wrap px-1 text-lg ">
              <div>Sort For :</div>
              <div
                className="mx-1"
                onClick={() => {
                  setSearchParams(prev => {
                    if (prev.get('sort') == 'rog') return prev;
                    prev.set('sort', 'rog');
                    return prev
                  })
                }}>
                <input type="radio" name="sort" value="rog" checked={searchParams.get('sort') == 'rog'} />
                <label htmlFor="rog" className="pl-1 pr-2">Brewing Trends</label>
              </div>
              <div
                className="mx-1"
                onClick={() => {
                  setSearchParams(prev => {
                    if (prev.get('sort') == 'depth') return prev;
                    prev.set('sort', 'depth');
                    return prev
                  })
                }}>
                <input type="radio" name="sort" value="depth" checked={searchParams.get('sort') == 'depth'} />
                <label htmlFor="depth" className="pl-1 pr-2">High Volume</label>
              </div>
            </div>
            <div className="w-full lg:w-auto shrink-0 lg:shrink flex text-lg mx-2">
              <div className="mx-3 flex">
                All Trends
                <Switch checked={searchParams.get('shortlisted-trends') == 't'} onChange={() => {
                  setSearchParams(prev => {
                    if (prev.get('shortlisted-trends') == 't') {
                      prev.delete('shortlisted-trends')
                    } else {
                      prev.set('shortlisted-trends', 't')
                    }
                    return prev
                  })
                }}
                />
                Shortlisted Trends
              </div>
              <Switch checked={showTabular} onChange={() => {
                setShowTabular(prev => !prev)
              }} />Compare Assortment
              {

                searchParams.get('tabular') == 't' ? <>
                  <select
                    value={searchParams.get('retailertime')}
                    onChange={(e) => {
                      setSearchParams(prev => {
                        prev.set('retailertime', e.target.value)
                        return prev
                      })
                    }}
                    className="p-1 ml-2 mr-2 rounded text-sm"
                  >
                    <option disabled value={""}>Retailer timeframe</option>
                    <option value={"30"}>One month</option>
                    <option value={"60"}>Two months</option>
                    <option value={"90"}>Three months</option>
                    <option value={"180"}>Six months</option>
                    <option value={"365"}>One year</option>
                  </select>


                </>

                  : null}
              <MinimumForecastDropdown
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                minforecastOptions={minimumForecastOptions}
              />
              <NewMeComponent showNewme={showNewmeComponent}>
                <NewmeCsvDownload tabular={showTabular} trends={trends} loading={loading} />
              </NewMeComponent>
            </div>
            <div className="w-full lg:w-auto shrink-0 lg:shrink flex text-lg mx-2">
              <select
                className="text-sm p-1 border rounded-lg"
                value={searchParams.get('retailer-collection-id') || ''}
                onChange={e => {
                  setSearchParams(prev => {
                    prev.set('retailer-collection-id', e.target.value)
                    return prev
                  })
                }}>
                <option disabled value={''}>Select retailer collection</option>
                {
                  allCollectionNames.map(c => <option key={c._id} value={c._id}>{c.collectionName}</option>)
                }
              </select>
              {searchParams.get('retailer-collection-id') ? <button onClick={e => {
                setSearchParams(prev => {
                  prev.delete('retailer-collection-id')
                  return prev
                })
              }}
                className="p-1 rounded "
              >
                <IoIosRemoveCircle color="black" />
              </button> : null}
            </div>
            {false && isMobile ? <div className="w-full pr-4 pb-1 flex justify-end lg:hidden"><button className={showGeographyAndCategoryFilter ? 'bg-white' : 'bg-white'} onClick={() => setShowGeographyAndCategoryFilter(prev => (!prev))}><FaFilter /></button></div> : null}
            {!isMobile || showGeographyAndCategoryFilter ? <div className="flex border-b lg:border-b-0 border-b-slate-400 w-full lg:w-auto pb-1 px-1 flex-wrap" >
              {false && searchParams.get('gender') != 'M' && <div className="w-full lg:w-auto shrink-0 lg:shrink flex flex-wrap px-1">
                <div>Sort For :</div>
                <div
                  className="mx-1"
                  onClick={() => {
                    setSearchParams(prev => {
                      if (prev.get('sort') == 'rog') return prev;
                      prev.set('sort', 'rog');
                      return prev
                    })
                  }}>
                  <input type="radio" name="sort" value="rog" checked={searchParams.get('sort') == 'rog'} />
                  <label htmlFor="rog" className="pl-1 pr-2">Brewing Trends</label>
                </div>
                <div
                  className="mx-1"
                  onClick={() => {
                    setSearchParams(prev => {
                      if (prev.get('sort') == 'depth') return prev;
                      prev.set('sort', 'depth');
                      return prev
                    })
                  }}>
                  <input type="radio" name="sort" value="depth" checked={searchParams.get('sort') == 'depth'} />
                  <label htmlFor="depth" className="pl-1 pr-2">Popular Trends</label>
                </div>

              </div>}
            </div> : null}
          </div>
          {userLoggedIn && userLoggedIn.admin ? <div className="flex">
            Hide trends below 0.25%<Switch checked={!hidebelow25percenttrends} onChange={updateHideBelow25PercentTrends} /> Show all trends
          </div> : null}
        </div>
      </div>

      <NewMeComponent showNewme={showNewmeComponent}>
        <div className="flex px-2">
          <StyleProcureCountUpdate gender={searchParams.get('gender')} category={searchParams.get('category')} />
        </div>
      </NewMeComponent>
      {
        false && (
          (searchParams.get('gender') == 'F' && !["Bags", "Footwear", "non-apparel", "Ethinic Wear"].includes(searchParams.get('category'))) ||
          (searchParams.get('gender') == 'M' && !["Bags", "Footwear", "non-apparel", "Ethinic Wear"].includes(searchParams.get('category')))
        ) ? <div className="flex px-2  mt-4 lg:mt-1">
          <div>
            <div className="flex">
              <label className="mr-4">Spotted Trends
                <input type={'radio'}
                  value='spotted'
                  name="spotted"
                  checked={!searchParams.has("validated") || searchParams.get('validated') == 'false'}
                  onChange={e => {
                    setSearchParams(prev => {
                      if (e.target.value == 'spotted') {
                        prev.set('validated', 'false')
                      } else {
                        prev.set('validated', 'true')
                      }
                      return prev
                    })
                  }}
                  className="mx-1"
                />
              </label>
              <label className="mr-2">Validated Trends Only
                <input type={'radio'}
                  value='validated'
                  name="validated"
                  checked={searchParams.get("validated") == 'true'}
                  onChange={e => {
                    setSearchParams(prev => {
                      if (e.target.value == 'spotted') {
                        prev.set('validated', 'false')
                      } else {
                        prev.set('validated', 'true')
                      }
                      return prev
                    })
                  }}
                  className="mx-1"
                />
              </label>
              {
                searchParams.get('validated') == 'true' ? <ValidatedTrendsFilters filters={validationFilters} setFilters={setValidationFilters} />
                  : null
              }
            </div>
          </div>
        </div> : null
      }
    </div>

    {!loading && showTabular ? <div className="flex justify-center">

      {
        showTabular
          ? <p className="mx-1">Showing 1-{tabularTrends.filter(t => roundtocloses0_5_value(showFloatToPercentage(t.forecastShare)) >= parseFloat(searchParams.get('min-forecast'))).length} of {tabularTrends.filter(t => roundtocloses0_5_value(showFloatToPercentage(t.forecastShare)) >= parseFloat(searchParams.get('min-forecast'))).length}</p>
          : <p className="mx-1">Showing 1-{trends.length} of {count}</p>
      }

    </div> : null}
    {
      trends.map((trend, index) => <>
        <DepthToolTip trend={trend} level={0} category={searchParams.get('category')} />
        {false ? trend.images.map(image => <TrendTooltip image={image} trendType="social" key={image.mediaId} category={searchParams.get('category')} />) : null}
      </>)
    }
    {showTabular ? <div className="px-2 min-w-[100vw] ">
      <TabularNewsFeed
        newsfeedtrends={tabularTrends}
        setNewsFeedTrends={setTabularTrends}
        setProductsPopupTrend={setSelectedTrend}
        searchedCategory={searchParams.get('category')}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        showNewmeComponent={showNewmeComponent}
        forAllTrends={forAllTrends}
        hideTrend={hideTrend}
      />
    </div> : <div className="p-2">
      {
        trends.map((trend, i) => <NewsFeedTrend trend={trend} rank={i + 1} allCollectionNames={allCollectionNames} addImageToCollection={socialAddImageToCollectionWrapper} retailerAddImageToCollection={retailerAddImageToCollectionWrapper} collectionSets={socialcollectionSets} retailercollectionSets={retailercollectionSets} fetchCollections={getCollectionNames} trendType={'social'} gender={searchParams.get('gender')} category={searchParams.get('category')} forAllTrends={forAllTrends} hideTrend={hideTrend} setSearchParams={setSearchParams} searchParams={searchParams} type={searchParams.get('type') == 'retailer' ? 'retailer' : 'social'} setImagePopupData={setImagePopupDataWrapper} showNewmeComponent={showNewmeComponent} companyName={userLoggedIn.company} retailerKey={retailerKey} />)
      }
    </div>}

    <Loadingwrapper loading={loading} className="mb-4 lg:mb-40" textToShow={'Building feed.. please wait.. ET 1 min…'}>

      <div className="flex justify-center" hidden={showTabular}>


        <button className="primary-btn  " onClick={() => setPage(prev => prev + 1)}
          hidden={showTabular || (trends.length >= count)}
        >Load More</button>
      </div>
      <div className="flex mb-6">
        {
          showTabular
            ? <p className="mx-1">Showing 1-{tabularTrends.filter(t => roundtocloses0_5_value(showFloatToPercentage(t.forecastShare)) >= parseFloat(searchParams.get('min-forecast'))).length} of {tabularTrends.filter(t => roundtocloses0_5_value(showFloatToPercentage(t.forecastShare)) >= parseFloat(searchParams.get('min-forecast'))).length}</p>
            : <p className="mx-1">Showing 1-{trends.length} of {count}</p>
        }

      </div>
      {
        !showTabular && trends.length == 0 ? <div className="p-4 flex justify-center items-center">
          <p className="m-2">Checkout: </p>
          <a
            href={`/v2-leaderboard?gender=${searchParams.get('M') ? 'Male' : 'Female'}&category=${searchParams.get('category')}&time=15+days`}
            className="primary-btn m-2"
          >Trend Leaderboard</a>
          <a
            href={`/design-recipe-images?gender=${searchParams.get('gender')}&category=${searchParams.get('category')}&time=15+days`}
            className="primary-btn m-2"
          >Product Leaderboard</a>
        </div> : null
      }
      <p className="my-6 text-center" hidden={(showTabular ? tabularTrends.length : trends.length) < count}>End Of results</p>
    </Loadingwrapper>

    <NewsFeedShareImagePopup imagePopupData={imagePopupData} setImagePopupData={setImagePopupData} />

    <Popup isPopUp={selectedTrend != null} setIsPopUp={() => { setSelectedTrend(null); }}>
      {
        selectedTrend
          ? <TrendImages searchParams={searchParams} trendType={'both'} tag={selectedTrend.tag} value={selectedTrend.value} category={selectedTrend.category} isCoord={selectedTrend && selectedTrend.iscoord}
            selectedretailer={selectedTrend.productsRetailer}
          />
          : null
      }
    </Popup>


  </div>
}

export default NewsFeed
